import { Association } from '@/models/associations/association';
import { GenericResult } from '@/models/common/results/generic-result';
import { UpdateAdminResult } from '@/models/common/results/update-admin-result';
import { UpdateCompanyResult } from '@/models/common/results/update-company-result';
import { Company } from '@/models/companies/company';
import { axiosService } from '.';

export default class AssociationsService {
    public async getAssociation(id: number): Promise<Association> {
        return new Association((await axiosService.instance.get(`associations/organization/${id}`)).data);
    }

    public async createAssociation(association: Association): Promise<GenericResult> {
        return new GenericResult((await axiosService.instance.post('associations/organization/new', association)).data);
    }

    public async updateAssociation(asssociation: Association): Promise<boolean> {
        return (await axiosService.instance.post('associations/organization/update', asssociation)).data;
    }

    public async updateAssociationCompany(id: number, company: Company): Promise<UpdateCompanyResult> {
        return new UpdateCompanyResult((await axiosService.instance.post(`associations/organization/update-company/${id}`, company)).data);
    }

    public async updateAssociationOwner(associationId: number, ownerId: number, ownerEmail?: string): Promise<UpdateAdminResult> {
        return new UpdateAdminResult((await axiosService.instance.post(`associations/organization/update-owner/${associationId}/${ownerId}?ownerEmail=${ownerEmail}`)).data);
    }

    public async updateAssociationInvitedOwnerEmail(associationId: number, invitedOwnerEmail: string): Promise<UpdateAdminResult> {
        return (await axiosService.instance.post(`associations/organization/update-invited-owner-email/${associationId}?invitedOwnerEmail=${invitedOwnerEmail}`)).data;
    }
}

export const associationsService = new AssociationsService();
